<template >
  <!--
  <pre>
    TextAreaSegment.inputModel {{modelValue.length}}
    {{modelValue}}
  </pre>
  -->
  <template
   v-if="lang"
  >

    <ul class="nav nav-tabs mb-2">
      <li
          v-for="(langItem, langIndex)  in lang"
          class="nav-item"
      >
        <a
            :class="'nav-link' + ((activeTab == langIndex)? ' active':'')"
            @click.prevent="changeTab(langIndex)"
            href="#"
        >
          <country-flag
              :country='langItem.flag'
              size="small"
          />
          {{langItem.title}}

        </a>
      </li>
    </ul>

    <template
        v-for="(langItem, langIndex)  in lang"
    >
      <div
          v-show="activeTab == langIndex"
      >
        <input
            v-model="inputModel[langIndex]"
            :id="inputObj.name + '_lang_' + langIndex"
            type="text"
            class="form-control"
        />
      </div>
    </template>

  </template>
  <template
      v-else
  >
  <textarea
      v-if="modelValue && modelValue.length> lengthLimit"
      :value="modelValue"
      ref="input"
      class="form-control"
  >
    {{modelValue}}
  </textarea>

    <input
        v-else
        ref="textarea"
        type="text"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="form-control"
    >

  </template>





</template>





<script>

import DisplayDebug from "@/components/general/DisplayDebug.vue";
import CountryFlag from "vue-country-flag-next"
import htmlEditor2 from "@/components/content/htmlEditor_v2.vue";
export default {
  name: "TextSegment",
  components: {
    htmlEditor2,
    CountryFlag,
    DisplayDebug
  },
  props: {
    "segmentsObj": [Object, Array],
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [String, Object],
    "lang": {
      type: [Object],
      required: false,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
    "config": {
      type: [Object],
      required: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      lengthLimit: 100,
      inputModel: null,
      activeTab: null,
    }
  },
  created() {
    if(this.lang){
      this.inputModel = {}
      for (const i in this.lang){
        //console.log('dev TextAreaSegment created obsah', i, this.inputObj.obsah)
        if(this.activeTab === null) {
          this.activeTab = i;
        }
        if(
            this.inputObj.obsah
            && typeof this.inputObj.obsah[i] != 'undefined'
        ) {
          this.inputModel[i] = this.inputObj.obsah[i];
        }else{
          this.inputModel[i] = null
        }
      }

    }else{
      this.inputModel = this.inputObj.obsah;
    }

  },
  methods: {
    changeTab(index) {
      this.activeTab = index;
    }
  },
  watch: {
    activeLang: {
      handler() {
        this.activeTab = this.activeLang;
      },
      deep: true,
      immediate: true
    },
    inputObj: {
      handler() {
        //  this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    inputModel( newVal){
      //console.log("dev inputModel TextAreaSegment xxxx", newVal)
      this.$emit('update:modelValue', newVal )
    },
  },
};
</script>